// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperBrowserPreviewList-cls1_FQ-","cls2":"PaperBrowserPreviewList-cls2_xL9 PaperBrowserPreviewList-cls1_FQ-"};